import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Logo } from "../../components/common/Logo";

const HelpPage = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-background-page dark:bg-neutral-950 flex flex-col">
            {/* Header */}
            <div className="h-16 flex items-center px-6 border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 sticky top-0 z-10">
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="p-2 -ml-2 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors text-neutral-500 dark:text-neutral-400"
                        aria-label={String(t("actions.back"))}
                    >
                        <span className="w-5 h-5" style={{maskImage: `url(https://cdn.dashbal.com/assets/icon_ffed198c.svg)`, WebkitMaskImage: `url(https://cdn.dashbal.com/assets/icon_ffed198c.svg)`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: 'center', WebkitMaskPosition: 'center', maskSize: 'contain', WebkitMaskSize: 'contain', backgroundColor: 'currentColor', display: 'inline-block'}} role='img' />
                    </button>
                    <div className="flex items-center gap-2 font-bold text-lg text-neutral-900 dark:text-neutral-100">
                        <Logo className="w-6 h-6" />
                        <span>{t("help.center", "Help Center")}</span>
                    </div>
                </div>
            </div>

            <main className="flex-1 p-6 lg:p-10 max-w-3xl mx-auto w-full">
                <div className="bg-white dark:bg-neutral-900 rounded-xl border border-neutral-200 dark:border-neutral-800 shadow-sm overflow-hidden">
                    <div className="p-8">
                        <div className="text-center mb-10">
                            <h2 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100 mb-2">{t("help.howCanWeHelp", "How can we help?")}</h2>
                            <p className="text-neutral-600 dark:text-neutral-400 font-light">{t("help.sendMessageDesc", "Send us a message and we'll get back to you as soon as possible.")}</p>
                        </div>

                        <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label htmlFor="name" className="block text-xs font-bold text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-2">
                                        {t("help.name", "Name")}
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="w-full h-11 px-4 bg-neutral-50 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg text-sm text-neutral-900 dark:text-neutral-100 focus:ring-2 focus:ring-accent-primary/20 focus:border-accent-primary transition-all outline-none"
                                        placeholder={String(t("help.namePlaceholder", "Your name"))}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="block text-xs font-bold text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-2">
                                        {t("help.email", "Email")}
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="w-full h-11 px-4 bg-neutral-50 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg text-sm text-neutral-900 dark:text-neutral-100 focus:ring-2 focus:ring-accent-primary/20 focus:border-accent-primary transition-all outline-none"
                                        placeholder={String(t("help.emailPlaceholder", "your@email.com"))}
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="subject" className="block text-xs font-bold text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-2">
                                    {t("help.subject", "Subject")}
                                </label>
                                <select id="subject" className="w-full h-11 px-4 bg-neutral-50 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg text-sm text-neutral-900 dark:text-neutral-100 focus:ring-2 focus:ring-accent-primary/20 focus:border-accent-primary transition-all outline-none appearance-none">
                                    <option>{t("help.generalInquiry", "General Inquiry")}</option>
                                    <option>{t("help.technicalSupport", "Technical Support")}</option>
                                    <option>{t("help.billingQuestion", "Billing Question")}</option>
                                    <option>{t("help.featureRequest", "Feature Request")}</option>
                                    <option>{t("help.other", "Other")}</option>
                                </select>
                            </div>

                            <div>
                                <label htmlFor="message" className="block text-xs font-bold text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-2">
                                    {t("help.message", "Message")}
                                </label>
                                <textarea
                                    id="message"
                                    rows={5}
                                    className="w-full p-4 bg-neutral-50 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg text-sm text-neutral-900 dark:text-neutral-100 focus:ring-2 focus:ring-accent-primary/20 focus:border-accent-primary transition-all outline-none resize-none"
                                    placeholder={String(t("help.messagePlaceholder", "Tell us what's on your mind..."))}
                                />
                            </div>

                            <button type="submit" className="w-full h-12 bg-accent-primary hover:bg-accent-primary/90 text-white font-bold rounded-lg transition-all shadow-sm active:scale-[0.98]">
                                {t("help.sendMessage", "Send Message")}
                            </button>
                        </form>
                    </div>
                    <div className="bg-neutral-50 dark:bg-neutral-800/50 p-6 border-t border-neutral-200 dark:border-neutral-800 text-center text-sm text-neutral-600 dark:text-neutral-400">
                        <div className="mb-4">
                            {t("help.orEmailUs", "Or email us at")} <a href="mailto:support@dashbal.com" className="text-accent-primary hover:underline font-bold">support@dashbal.com</a>
                        </div>
                        <div className="flex justify-center gap-6 text-xs text-neutral-400 dark:text-neutral-500">
                            <button onClick={() => navigate("/terms")} className="hover:text-neutral-900 dark:hover:text-neutral-200 transition-colors">
                                {t("legal.tos.title", "Terms of Service")}
                            </button>
                            <button onClick={() => navigate("/privacy")} className="hover:text-neutral-900 dark:hover:text-neutral-200 transition-colors">
                                {t("legal.privacy.title", "Privacy Policy")}
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default HelpPage;

